export default __webpack_public_path__ + "static/media/frame6.ac0d7720.webp";